import { FC, memo } from 'react'

import { Button, Text } from '@cash-me/react-components'

import { Col, Grid } from 'components/grid'
import { VideoPlayer } from 'components/video-player'
import useWindowSize from 'hooks/useWindowSize'
import { pushDataLayer } from 'utils/push-data-layer'

import { CODE_OF_CONDUCT_URL } from '../documents'

import * as S from './styles'

const dataLayer = {
  category: 'Clique',
  action: 'Botões',
  label: 'Código de Conduta e Ética - Programa de Integridade  - Acesse o nosso código'
}

const CodeConduct: FC = memo(() => {
  const { isDesktop } = useWindowSize()

  const handleClick = () => {
    pushDataLayer(dataLayer)
    window.open(CODE_OF_CONDUCT_URL, '_blank', 'noopener,noreferrer')
  }

  return (
    <S.Section $bg="contrast">
      <Grid col={{ phone: 1, tablet: 12 }}>
        <Col col={{ tablet: 10, desktop: 10 }} start={{ tablet: 2, desktop: 2 }}>
          <S.Content>
            <S.Infos>
              <Text as="h2" size="heading2" weight="medium" color="var(--colors-neutral-text-contrast-default)">
                <Text as="span" size="heading2" weight="medium" color="var(--colors-pink-text-contrast)">
                  Código
                </Text>{' '}
                de
                <br />
                Conduta Ética
              </Text>

              <S.Paragraphs>
                <Text size="heading4" color="var(--colors-neutral-text-contrast-default)">
                  O Código de Conduta Ética reflete o nosso engajamento para atuar com integridade. Nossas práticas
                  diárias são sustentadas pelas legislações vigentes e as boas práticas de governança corporativa.
                </Text>
                <Text size="heading4" color="var(--colors-neutral-text-contrast-default)">
                  Os valores da nossa cultura também são vivenciados por meio das ações que orientam o nosso dia a dia,
                  impulsionando os princípios do nosso Programa de Integridade.
                </Text>
                <Text size="heading4" color="var(--colors-neutral-text-contrast-default)">
                  Para saber mais, acesse o nosso código no botão abaixo.
                </Text>
              </S.Paragraphs>

              <Button {...(isDesktop ? { size: 'lg' } : { size: 'md' })} onClick={handleClick}>
                Acesse o nosso código
              </Button>
            </S.Infos>

            <S.Frames>
              <S.FrameCyan aria-hidden />
              <S.FrameMagenta aria-hidden />
              <S.Video>
                <VideoPlayer
                  videoUrl="https://www.youtube-nocookie.com/embed/A46Vlqvj_6g?controls=0&autoplay=1"
                  videoTitle="Marina D'Aulisio apresentando o Programa de Integridade"
                  width={600}
                  height={338}
                  imagePlaceholder={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/integrity-program/video-conduta.webp`}
                  alt="Marina D'Aulisio apresentando o Programa de Integridade"
                />
              </S.Video>
            </S.Frames>
          </S.Content>
        </Col>
      </Grid>
    </S.Section>
  )
})

CodeConduct.displayName = 'CodeConduct'

export default CodeConduct
